(function(window, templates) {
   'use strict';

   window.TSC = window.TSC || {};

   window.TSC.preRollView = (function() {
      var _preRollTemplate;

      if (templates && templates.pre_roll_container_template) {
         _preRollTemplate = templates.pre_roll_container_template;
      } else {
         throw Error('TSC.preRollView: Template not found');
      }

      return {
         render: function(preRollSrc) {
            var context = {preRollSizeClass: 'preRoll-fullPage', preRollSrc: preRollSrc};
            return _preRollTemplate(context);
         }
      };
   })();
}(window, window.TSC.templates));
